class BundleOffer extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('.pebbl-bundle-offer__form');
    this.checkboxes = Array.from(this.querySelectorAll('.pebbl-bundle-offer__checkbox'));
    this.totalValue = this.querySelector('.pebbl-bundle-offer__total-value');
    this.submitButton = this.querySelector('.pebbl-bundle-offer__submit');
    this.cart = document.querySelector('cart-drawer');
    this.mainVariantId = this.dataset.mainVariantId;

    this.colorSelects = Array.from(this.querySelectorAll('[data-bundle-color]'));

    this.checkboxes.forEach((checkbox) => checkbox.addEventListener('change', this.updateTotal.bind(this)));
    this.colorSelects.forEach((select) => select.addEventListener('change', this.onColorChange.bind(this)));
    this.form.addEventListener('submit', this.onSubmit.bind(this));
    this.updateTotal();
  }

  /* Farbwechsel: die Bundle-Variante haengt an der Farbe, also muessen
     Varianten-ID, Preis und die beiden angezeigten Betraege mitwandern. */
  onColorChange(event) {
    const select = event.currentTarget;
    const option = select.options[select.selectedIndex];
    const item = select.closest('.pebbl-bundle-offer__item');
    if (!item || !option) return;

    const checkbox = item.querySelector('.pebbl-bundle-offer__checkbox');
    if (checkbox) {
      checkbox.dataset.variantId = option.value;
      checkbox.dataset.price = option.dataset.price;
    }

    const img = item.querySelector('.pebbl-bundle-offer__item-image img');
    if (img && option.dataset.image) {
      img.removeAttribute('srcset');
      img.src = option.dataset.image;
    }

    const bundleEl = item.querySelector('[data-price-bundle]');
    const regularEl = item.querySelector('[data-price-regular]');
    if (bundleEl) bundleEl.textContent = option.dataset.bundleMoney;
    if (regularEl) regularEl.textContent = option.dataset.regularMoney;

    this.updateTotal();
  }

  updateTotal() {
    if (!this.totalValue) return;
    const mainPrice = parseFloat(this.totalValue.dataset.mainPrice) || 0;
    const total = this.checkboxes.reduce((sum, checkbox) => {
      return checkbox.checked ? sum + (parseFloat(checkbox.dataset.price) || 0) : sum;
    }, mainPrice);
    this.totalValue.textContent = this.formatMoney(total);
  }

  formatMoney(amount) {
    return `${amount.toFixed(2).replace('.', ',')} €`;
  }

  onSubmit(event) {
    event.preventDefault();
    if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

    const items = [{ id: this.mainVariantId, quantity: 1 }];
    this.checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        items.push({ id: checkbox.dataset.variantId, quantity: 1 });
      }
    });

    this.submitButton.setAttribute('aria-disabled', 'true');
    this.submitButton.classList.add('loading');
    const spinner = this.submitButton.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');

    const config = fetchConfig('json');
    const sectionsToRender = this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : [];
    config.body = JSON.stringify({
      items,
      sections: sectionsToRender,
      sections_url: window.location.pathname,
    });

    fetch(`${window.routes.cart_add_url}.js`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.error(response.description || response.message);
          return;
        }
        if (this.cart) {
          this.cart.renderContents(response);
        } else {
          window.location = window.routes.cart_url;
        }
      })
      .catch((error) => console.error(error))
      .finally(() => {
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
      });
  }
}

customElements.define('bundle-offer', BundleOffer);
